module.exports = __webpack_public_path__ + "media/images/referral-bg-89ad5e08dc85c2c1d8954e07536c7351.png";